import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  Share,
} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import CustomButton from '../../../commonComponents/CustomButton';
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";

const JoinFirst = ({closeBottomSheet, isLoggedIn}) => {
  return (
    <View style={{paddingHorizontal: 12, paddingVertical: 15}}>
      <Text
        style={[
          globalFontStyle.appFontSubHeading,
          {color: Color.black, marginBottom: 12},
        ]}>
        {isLoggedIn
          ? 'You need to join the club first !'
          : 'Please Register First'}
      </Text>
      <Text style={[globalFontStyle.appFontSubText, {marginBottom: 15}]}>
        {isLoggedIn
          ? 'These events are exclusive for club members only. Please join the club' +
            'first in order to participate.'
          : 'In order to join the club, you need to register on ' +
            globalConfigurableData?.appName +
          ' first. Please click the button below to register your self'}
      </Text>
      <CustomButton
        btnText={'Okay'}
        btnType="normalBlue"
        onBtnClick={closeBottomSheet}
      />
    </View>
  );
};

export default JoinFirst;
